<ct-expansion-panel [configuration]="panelConfiguration" *ngIf="legendItemsConfiguration.visible"></ct-expansion-panel>

<ng-template #legendTemplate>

  <div class="legend-grid" *ngIf="legendItemsConfiguration.visible">

    <div *ngFor="let item of legendItemsConfiguration.legendsItem" class="legend-card"
      [style.backgroundColor]="getRgbaBackground(item.color)">

      <div class="legend-header">

        <div class="color-dot" [style.backgroundColor]="item.color"></div>
        <div class="label">{{ item.label }}</div>

      </div>

      <div class="description">{{ item.description }}</div>

    </div>

  </div>

</ng-template>